import React from 'react';

function PageLoader(props){
    return (
        <div>
            <div className="loading-bar"></div>
        </div>
    );
}
export default PageLoader;


// WEBPACK FOOTER //
// ./src/components/PageLoader.jsx